export enum LoginStorage {
    LOCATION_FROM = 'login_email_from',
    LOCATION_TO = 'login_email_to',
    USERNAME = 'login_username',
    LOGIN_TO = 'login_to',
    LOGIN_FROM = 'login_from',
}
